import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import SMSSolutions from './pages/SMSSolutions/SMSSolutions';
import VoiceSolutions from './pages/VoiceSolutions/VoiceSolutions';
import IVRSolutions from './pages/IVRSolutions/IVRSolutions';
import WhatsAppApi from './pages/WhatsAppMMS/WhatsAppApi';
import MissedCallService from './pages/MissedCallService/MissedCallService';
import EmailMarketing from './pages/EmailMarketing/EmailMarketing';
import TallySolutions from './pages/TallySolutions/TallySolutions';
import StockbrokerSoftware from './pages/StockbrokerSoftware/StockbrokerSoftware';
import RealEstateTracking from './pages/RealEstateTracking/RealEstateTracking';
import Pricing from './pages/Pricing/Pricing';
import ContactUs from './pages/ContactUs/ContactUs';
import WhatsAppFloatingButton from './components/WhatsAppFloatingButton';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services/sms" element={<SMSSolutions />} />
          <Route path="/services/voice" element={<VoiceSolutions />} />
          <Route path="/services/ivr" element={<IVRSolutions />} />
          <Route path="/services/WhatsAppApi" element={<WhatsAppApi />} />
          <Route path="/services/whatsapp-mms" element={<WhatsAppApi />} />
          <Route path="/services/whatsAppApi" element={<WhatsAppApi />} />
          <Route path="/services/missed-call" element={<MissedCallService />} />
          <Route path="/services/email-marketing" element={<EmailMarketing />} />
          <Route path="/services/tally" element={<TallySolutions />} />
          <Route path="/services/stockbroker" element={<StockbrokerSoftware />} />
          <Route path="/services/real-estate" element={<RealEstateTracking />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <WhatsAppFloatingButton />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
